import { z } from 'zod';

export const dealListItemSchema = z.object({
  id: z.union([z.string(), z.number()]).transform(String),
  dealName: z.string().optional().nullable(),
  name: z.string().optional().nullable(),
  dealStage: z.string().optional().nullable(),
  dealAmount: z.union([z.number(), z.string()]).optional().nullable(),
}).passthrough();

export const dealDetailSchema = dealListItemSchema.extend({
  clientId: z.union([z.string(), z.number()]).optional().nullable(),
  ownerUserId: z.union([z.string(), z.number()]).optional().nullable(),
}).passthrough();

export const realtimeDealPayloadSchema = z.object({
  type: z.string().optional(),
  eventType: z.string().optional(),
  entity_id: z.union([z.string(), z.number()]).optional().nullable(),
  data: z.record(z.unknown()).optional().nullable(),
}).passthrough();

export function parseDealList(rows) {
  if (!Array.isArray(rows)) return [];
  return rows.map((row) => {
    const result = dealListItemSchema.safeParse(row);
    if (!result.success) {
      console.warn('[zod] deal list soft-fail', result.error.flatten());
      return row;
    }
    return result.data;
  });
}

export function parseDealDetail(raw) {
  if (raw == null) return null;
  const result = dealDetailSchema.safeParse(raw);
  if (!result.success) {
    console.warn('[zod] deal detail soft-fail', result.error.flatten());
    return raw;
  }
  return result.data;
}

export function softCheckRealtimeDeal(msg) {
  const result = realtimeDealPayloadSchema.safeParse(msg);
  if (!result.success) {
    console.warn('[zod] realtime deal soft-fail', result.error.flatten());
    return msg;
  }
  return result.data;
}
